
























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Typography } from '@/components/atoms';

@Component({
  components: {
    Typography
  }
})
export default class CampaignAppPreview extends Vue {
  @Prop() bonusPercentage?: string;

  get tPrefix() {
    return 'sellCoins.campaign.sideBar';
  }

  get bonusPercentageText() {
    return this.bonusPercentage === 'Other' || this.bonusPercentage === '%'
      ? '--'
      : this.bonusPercentage;
  }
}
